import { Col, Row } from "reactstrap";
import { ShareIt } from "../../../../../Constants/Constants";
import { Link } from "react-router-dom";
import { ProductSocialLinks } from "../../../../../Data/Applications/ECommerce/ECommerce";
import { H6, LI, UL } from "../../../../../AbstractElements";

export const ProductSocial = () => {
  return (
    <>
      <Row className="py-1">
        <Col md="4">
          <H6 className="product-title mb-2">{ShareIt}</H6>
        </Col>
        <Col md="8">
          <div className="product-icon">
            <UL className="product-social simple-list flex-row">
              {ProductSocialLinks.map((item, index) => (
                <LI className="d-inline-block" key={index}>
                  <Link to={item.link} target="_blank">
                    <i className={item.text}></i>
                  </Link>
                </LI>
              ))}
            </UL>
          </div>
        </Col>
      </Row>
      <hr />
    </>
  );
};